import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PortalLinkService {

  localSubDomainPrefix = 'm00';

  constructor() { }

  // Returns the current environment (tenv2, tenv3, tenv6, tenv7, www (production))
  getEnvironment(forcedSubDomain) {
    let subDomain = window.location.host.split('.')[0];
    const forcedEnvironment = forcedSubDomain || '';
    const subDomainKeyArray = [
      { tenvKey: 'shoptenv', toRemove: 'shop' }, //shoptenvX
      { tenvKey: 'producertenv', toRemove: 'producer' }, //producertenvX
      { tenvKey: 'medicaretenv', toRemove: 'medicare' }, //medicaretenvX
      { tenvKey: 'securetenv', toRemove: 'secure' }, //sso secure

      { tenvKey: 'shopdenv', toRemove: 'shop' }, //shoptenvX
      { tenvKey: 'producerdenv', toRemove: 'producer' }, //producertenvX
      { tenvKey: 'medicaredenv', toRemove: 'medicare' }, //medicaretenvX
      { tenvKey: 'securedenv', toRemove: 'secure' }, //sso secure

      { tenvKey: this.localSubDomainPrefix, toRemove: '' } //local
    ];

    //skip if subdomain is www
    //for each other subdomain, we have to check if it's a prod or test subdomain
    //if prod do nothing, if test strip off the production prefix
    if (subDomain !== 'www') {
      let continueArray = true;
      subDomainKeyArray.forEach(subDomainKey => {
        if (continueArray && subDomain.indexOf(subDomainKey.tenvKey) === 0) {
          if (subDomainKey.tenvKey === this.localSubDomainPrefix) {
            subDomain = subDomain;
          } else {
            subDomain = subDomain.replace(
              subDomainKey.toRemove,
              forcedEnvironment
            );
          }
          continueArray = false;
        }
      });

      if (continueArray && forcedEnvironment) {
        subDomain = forcedEnvironment;
      }
    }

    if (!forcedSubDomain && (subDomain.indexOf('tenv') === -1 && subDomain.indexOf('denv') === -1)) {
      subDomain = 'www';
    }

    return subDomain;
  }

  getUrl(userArgs) {
    const urlArgs = Object.assign({},
      {
        domain: null,
        path: '/',
        forcedSubDomain: null
      },
      userArgs
    );
    const urlDomain = urlArgs.domain || 'highmark.com';
    let environment = this.getEnvironment(urlArgs.forcedSubDomain);
    let prePath = '';

    if (
      environment !== 'www' &&
      environment.indexOf('tenv') === -1 &&
      environment.indexOf(this.localSubDomainPrefix) === -1 &&
      (urlArgs.forcedSubDomain &&
        environment.indexOf(urlArgs.forcedSubDomain) === -1)
    ) {
      environment = 'www';
    }

    //If local, setting forcedSubDomain to pre path string
    if (
      environment.indexOf(this.localSubDomainPrefix) === 0 &&
      urlArgs.forcedSubDomain
    ) {
      if (urlArgs.forcedSubDomain !== 'secure') {
        prePath = '/' + urlArgs.forcedSubDomain;
      }
    }

    if (urlArgs.path) {
      //add leading slash if not present
      if (urlArgs.path.charAt(0) !== '/') {
        urlArgs.path = '/' + urlArgs.path;
      }
    }

    //Return fully qualified path
    return 'https://' + environment + '.' + urlDomain + prePath + urlArgs.path;
  }
}
